import { getActionTypeFromInstance, NGXS_PLUGINS } from "@ngxs/store";

import { Logout, authStateDefaults } from "@fitscovery/auth/data-access";
import { userStateDefaults } from "@fitscovery/user/data-access";
import { partnerStateDefaults, bankStateDefaults } from "@fitscovery/partner/data-access";
import { eventStateDefaults } from "@fitscovery/events/data-access";
import { membershipStateDefaults, pmsEmailTemplateStateDefaults } from "@fitscovery/membership/data-access-for-migration";
import { bookingStateDefaults } from "@fitscovery/booking/data-access";
import { workoutStateDefaults, programStateDefaults } from "@fitscovery/workouts/data-access";

function adminWebLogoutPlugin(state: any, action: any, next: any) {

  if (getActionTypeFromInstance(action) === Logout.type) {
    state = {
      auth: authStateDefaults,
      user: userStateDefaults,
      partner: partnerStateDefaults,
      events: eventStateDefaults,
      membership: membershipStateDefaults,
      bookings: bookingStateDefaults,

      workout: workoutStateDefaults,
      program: programStateDefaults,
      
      pmeEmailTemplate: pmsEmailTemplateStateDefaults,
      bank: bankStateDefaults,

      domain_bookings: state.domain_bookings,
      route: state.route,
      shared: state.shared,
      state: state.state
    };
  }

  return next(state, action);
}

export const AdminWebLogoutPluginProvider = {
  provide: NGXS_PLUGINS,
  useValue: adminWebLogoutPlugin,
  multi: true
};
